export default __webpack_public_path__ + "static/media/Ravi.4e9d9801.jpeg";